<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Contacts-Profile component
 */
export default {
  // PAGE DETAIKS
  page: {
    title: `Staff Profile`,
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, ModelListSelect },
  data() {
    return {
      title: "STAFF PROFILE FOR",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Staff Profile",
          active: true,
        },
      ],

      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "created_at",
          sortable: true,
          label: "DATE TIME",
        },
        {
          key: "action",
          sortable: true,
          label: "ACTIVITY PERFORMED",
        },
      ],

      // DATA
      staff_id: this.$route.params.staff,
      modal_id: "",
      users: {
        name: "",
        id: "",
        contact: "",
        date: "",
        position: "",
        email: "",
        gender: "",
        address: "",
      },
      genderOptions: [
        {
          id: 1,
          name: "Male",
        },
        {
          id: 2,
          name: "Female",
        },
      ],
      account: {
        staff_id: "",
        name: "",
        email: "",
        phone: "",
        role_id: "",
      },
      nameError: "",
      contactError: "",
      emailError: "",
      positionError: "",
      dateError: "",
      genderError: "",
      addressError: "",
    };
  },
  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("staffModule", [
      "staff_profile",
      "StaffSaveStatus",
      "StaffPositions",
      "StaffAudits",
      "user_roles",
      "activeUsers",
    ]),
    ...mapGetters("branch", ["GetBranch"]),
    ...mapGetters("auth", ["user_permissions", "userid", "branch_id"]),
    ...mapGetters("users", ["GetAdminUser"]),

    rows() {
      return this.StaffAudits ? this.StaffAudits.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.StaffAudits ? this.StaffAudits.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.closeMode(this.modal_id);
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchStaffProfile: "staffModule/fetchStaffProfile",
      FetchStaffPositions: "staffModule/fetchStaffPositions",
      FetchUserRoles: "staffModule/fetchRoles",
      FetchActiveUsers: "staffModule/fetchActiveUsers",
      EditStaff: "staffModule/editStaff",
      EnrolUser: "staffModule/enrolStaff",
      FetchBranch: "branch/fetchBranch",
      AuthenticatedUser: "auth/Authenticated_user",
      FetchAdminUsers: "users/fetchAdminUsers",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    showEditModal(staff) {
      this.users.name = staff.staffName;
      this.users.id = this.staff_id;
      this.users.email = staff.staffEmail;
      this.users.contact = staff.staffContact;
      this.users.date = staff.editDOB;
      this.users.address = staff.staffAddress;
      this.users.position = staff.position.id;
      this.users.gender = staff.staffGender;
    },

    editStaff(modalId) {
      this.modal_id = modalId;
      this.EditStaff(this.users);
    },
    enrollStaff(modalId) {
      this.modal_id = modalId;
      this.account.staff_id = this.staff_id;
      this.account.name = this.staff_profile.staffName;
      this.EnrolUser(this.account);
    },
    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END CLOSE MODEL
  },
  created() {
    this.FetchStaffProfile(this.$route.params.staff);
    this.FetchStaffPositions();
    this.FetchUserRoles();
    this.AuthenticatedUser();
    this.FetchBranch();
    this.FetchActiveUsers();
    this.FetchAdminUsers();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader
      :title="title + ' ' + staff_profile ? staff_profile.staffName : '--'"
      :items="items"
    />

    <center>
      <h3 v-if="!staff_profile" class="text-primary">
        <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
        Please wait...
      </h3>
    </center>
    <div class="form-group">
      <button @click="$router.go(-1)" class="btn btn-success mb-2">
        <i class="fas fa-arrow-circle-left"></i> Go Back
      </button>
    </div>
    <div class="row">
      <div class="col-xl-4">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-success p-3">
                  <h5 class="text-primary">
                    {{ staff_profile ? staff_profile.staffName : "--" }}
                  </h5>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-sm-8">
                <div class="avatar-lg profile-user-wid mb-4">
                  <img
                    src="@/assets/images/users/avatar-1.jpg"
                    alt
                    class="img-thumbnail rounded-circle"
                  />
                </div>

                <h5 class="font-size-13">
                  Staff Name:
                  <u>{{ staff_profile ? staff_profile.staffName : "--" }}</u>
                </h5>
                <h5 class="font-size-13">
                  Position: <u>{{ staff_profile.position.position_name }}</u>
                </h5>
              </div>

              <div class="col-sm-4">
                <div class="pt-4">
                  <div class="row">
                    <div class="col-12">
                      <h5 class="font-size-15">{{ staff_profile.Address }}</h5>
                      <p class="text-muted mb-0">Actions</p>
                    </div>
                    <div class="col-12"></div>
                  </div>
                  <div class="col-12">
                    <button
                      v-if="
                        user_permissions.edit_staff
                          ? user_permissions.edit_staff
                          : false
                      "
                      v-b-modal.edit-photo-modal
                      class="btn btn-primary btn-sm mt-4 mb-3"
                    >
                      <i class="fa fa-image"></i> Edit Photo
                    </button>
                  </div>
                  <div class="col-12">
                    <button
                      v-if="
                        user_permissions.edit_staff
                          ? user_permissions.edit_staff
                          : false
                      "
                      @click="showEditModal(staff_profile)"
                      v-b-modal.edit-staff-modal
                      class="btn btn-primary btn-sm mb-4"
                    >
                      <i class="fa fa-edit"></i> Edit Profile
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <h5 class="mt-4 text-primary" v-if="staff_profile.useraccount">
              OTHER DETAILS
            </h5>
            <template v-if="staff_profile.useraccount">
              <b-list-group>
                <b-list-group-item>
                  Became a User:
                  <strong>{{ staff_profile.useraccount.dateCreat }}</strong>
                </b-list-group-item>
                <b-list-group-item
                  >Tasks Done:
                  <strong>{{ staff_profile.useraccount.audits.length }}</strong>
                </b-list-group-item>
                <b-list-group-item
                  v-if="staff_profile.useraccount.pass.status == 1"
                  >Password:
                  <strong>{{
                    staff_profile.useraccount
                      ? staff_profile.useraccount.pass.temp_password
                      : "---"
                  }}</strong>
                </b-list-group-item>
              </b-list-group>
            </template>
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h4 class="card-title">DETAILS AND ACTIVITIES</h4>
              </div>
              <div class="col-3"></div>
            </div>
            <b-tabs pills justified content-class="p-3 text-muted">
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block"
                    >PERSONAL INFORMATION</span
                  >
                </template>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Full Name:</h5></div>
                  <div class="col-8">
                    <h6>
                      {{ staff_profile ? staff_profile.staffName : "--" }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Gender:</h5></div>
                  <div class="col-8">
                    <h6>
                      {{ staff_profile.staffGender == 1 ? "Male" : "Female" }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Mobile Number:</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.staffContact
                          ? staff_profile.staffContact
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Email</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.staffEmail
                          ? staff_profile.staffEmail
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Address</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.staffAddress
                          ? staff_profile.staffAddress
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Position</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.position.position_name
                          ? staff_profile.position.position_name
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Clinic Branch</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.branch.name
                          ? staff_profile.branch.name
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Date Of Birth</h5></div>
                  <div class="col-8">
                    <h6>{{ staff_profile.DOB ? staff_profile.DOB : "---" }}</h6>
                  </div>
                </div>
                <div class="row">
                  <hr />
                  <div class="col-4"><h5>Date Joined</h5></div>
                  <div class="col-8">
                    <h6>
                      {{
                        staff_profile.dateCreated
                          ? staff_profile.dateCreated
                          : "---"
                      }}
                    </h6>
                  </div>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cog"></i>
                  </span>
                  <span
                    v-if="staff_profile.useraccount"
                    class="d-none d-sm-inline-block"
                    >ACTIVITIES</span
                  >
                  <span v-else class="d-none d-sm-inline-block"
                    >ENROL STAFF</span
                  >
                </template>
                <div class="row" v-if="!staff_profile.useraccount">
                  <div class="form-group col-md-12">
                    <div
                      v-if="activeUsers >= staff_profile.clinic.package.users"
                    >
                      <b-alert show variant="warning">
                        <h4 class="alert-heading">Message!</h4>
                        <h3 class="block">
                          You reached your user limit of
                          {{ staff_profile.clinic.package.users }} users
                        </h3>
                        <p>
                          You can not enroll
                          <strong>{{ staff_profile.staffName }}</strong>
                          because your subscription package is
                          <strong>{{
                            staff_profile.clinic.package.pack_name
                          }}</strong>
                          with a limit of
                          {{ staff_profile.clinic.package.users }} users only.
                          You may need to contact Nugsoft Technologies to
                          upgrade your subscription. Users = {{ activeUsers }}
                        </p>
                        <hr />
                        <p class="mb-0">Thank You for using Clinic Plus</p>
                      </b-alert>
                    </div>
                    <button
                      v-if="
                        activeUsers < staff_profile.clinic.package.users &&
                        user_permissions.enroll_staff
                      "
                      v-b-modal.enrol-staff
                      class="btn btn-success float-end"
                    >
                      <i class="fa fa-plus-circle"></i> Enrol Staff
                    </button>
                  </div>
                </div>
                <div v-else class="table-responsive">
                  <div class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div id="tickets-table_length" class="dataTables_length">
                        <label class="d-inline-flex align-items-center">
                          Show&nbsp;
                          <b-form-select
                            class="form-select form-select-sm"
                            v-model="perPage"
                            size="sm"
                            :options="pageOptions"
                          ></b-form-select
                          >&nbsp;entries
                        </label>
                      </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-12 col-md-6">
                      <div
                        id="tickets-table_filter"
                        class="dataTables_filter text-md-end"
                      >
                        <label class="d-inline-flex align-items-center">
                          Search:
                          <b-form-input
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                          ></b-form-input>
                        </label>
                      </div>
                    </div>
                    <!-- End search -->
                  </div>
                  <b-table
                    v-if="StaffAudits"
                    class="datatables"
                    :items="StaffAudits ? StaffAudits : []"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                  >
                    <template #cell(index)="data">
                      {{ data.index + 1 }}
                    </template>
                  </b-table>
                  <div class="row">
                    <div class="col">
                      <div
                        class="
                          dataTables_paginate
                          paging_simple_numbers
                          float-end
                        "
                      >
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>

          <b-spinner
            v-if="!staff_profile.staffName"
            style="float: right"
            class="m-2"
            variant="primary"
            role="status"
          ></b-spinner>
          <!-- ADD SERVICE MODEL -->
          <div class="col-sm-6 col-md-4 col-xl-3">
            <div class="my-4 text-center">
              <!-- Enrol staff modal -->
              <b-modal
                hide-footer
                id="enrol-staff"
                :title="'Enrol ' + staff_profile.staffName + ' as a User'"
                title-class="font-18"
              >
                <div class="form-group">
                  <label class="col-form-label">Role</label>
                  <model-list-select
                    :list="user_roles ? user_roles : []"
                    v-model="account.role_id"
                    option-value="id"
                    option-text="roleName"
                    placeholder="Select Role"
                  >
                  </model-list-select>
                </div>
                <div class="form-group" v-if="GetAdminUser == userid">
                  <label class="col-form-label">Branch</label>
                  <model-list-select
                    :list="GetBranch ? GetBranch : []"
                    v-model="account.branch_id"
                    option-value="Id"
                    option-text="branchName"
                    placeholder="Select Branch"
                  >
                  </model-list-select>
                </div>
                <div v-if="!staff_profile.staffEmail" class="form-group">
                  <label class="col-form-label">Email</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="account.email"
                  />
                </div>
                <div v-if="!staff_profile.staffContact" class="form-group">
                  <label class="col-form-label">Phone Number</label>
                  <input
                    type="number"
                    min="9"
                    max="12"
                    class="form-control"
                    v-model="account.phone"
                  />
                </div>
                <div class="modal-footer">
                  <button
                    @click="closeMode('enrol-staff')"
                    type="button"
                    class="btn btn-secondary float-start"
                  >
                    <i class="fa fa-times"></i> Cancel
                  </button>
                  <button
                    @click="enrollStaff('enrol-staff')"
                    type="submit"
                    class="btn btn-success"
                  >
                    <i class="fa fa-check"></i> Submit
                  </button>
                </div>
              </b-modal>
              <!-- Edit Photo modal -->
              <b-modal
                hide-footer
                id="edit-photo-modal"
                :title="'CHOOSE NEW PHOTO'"
                title-class="font-18"
              >
                <div class="form-group">
                  <label class="col-form-label" for="password">New Photo</label>
                  <input type="file" class="form-control" />
                </div>
                <div class="modal-footer">
                  <button
                    @click="closeMode('edit-photo-modal')"
                    type="button"
                    class="btn btn-secondary float-start"
                  >
                    <i class="fa fa-times"></i> Cancel
                  </button>
                  <button type="submit" class="btn btn-success">
                    <i class="fa fa-check"></i> Submit
                  </button>
                </div>
              </b-modal>
              <!-- Edit profile -->
              <b-modal
                hide-footer
                id="edit-staff-modal"
                :title="'EDIT STAFF DETAILS'"
                title-class="font-18"
              >
                <div class="col-12">
                  <div class="form-group mb-3" v-if="branch_id == 0">
                    <label>Select Branch</label>
                    <select
                      placeholder="Select Branch"
                      v-model="users.branch_id"
                      class="form-control"
                    >
                      <!-- <option value="">Select Branch</option> -->
                      <option
                        v-for="item in GetBranch"
                        :value="item.Id"
                        :key="item.Id"
                      >
                        {{ item.branchName }}
                      </option>
                    </select>
                    <div class="text-danger" v-if="branchError">
                      <em>{{ branchError }}</em>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="name">Staff Name</label>
                    <input
                      id="name"
                      v-model="users.name"
                      type="text"
                      class="form-control"
                      placeholder="Insert name"
                      @input="resetErrors()"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="name">Contact</label>
                    <input
                      id="name"
                      v-model="users.contact"
                      type="text"
                      class="form-control"
                      placeholder="Insert contact"
                      @input="resetErrors()"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label>Email</label>
                    <input
                      v-model="users.email"
                      type="email"
                      class="form-control"
                      placeholder="Enter Email Address"
                      @input="resetErrors()"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="date">Date Of Birth</label>
                    <input
                      id="date"
                      v-model="users.date"
                      type="date"
                      class="form-control"
                      placeholder="Insert date of birth"
                      @input="resetErrors()"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label>Gender</label>
                    <model-list-select
                      :list="genderOptions ? genderOptions : []"
                      v-model="users.gender"
                      option-value="id"
                      option-text="name"
                      class="mb-3"
                      placeholder="Select Gender"
                      @input="resetErrors()"
                    >
                    </model-list-select>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label>Home Address</label>
                    <input
                      v-model="users.address"
                      type="text"
                      class="form-control"
                      placeholder="Enter Staff Address"
                      @input="resetErrors()"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <label>Position</label>
                  <model-list-select
                    :list="StaffPositions ? StaffPositions : []"
                    v-model="users.position"
                    option-value="id"
                    option-text="positionName"
                    class="mb-3"
                    placeholder="Select Staff Position"
                    @input="resetErrors()"
                  >
                  </model-list-select>
                </div>
                <div class="modal-footer">
                  <button
                    @click="closeMode('edit-staff-modal')"
                    type="button"
                    class="btn btn-secondary float-start"
                  >
                    <i class="fa fa-times"></i> Cancel
                  </button>
                  <button
                    @click="editStaff('edit-staff-modal')"
                    type="submit"
                    class="btn btn-success"
                  >
                    <i class="fa fa-check"></i> Submit
                    <b-spinner
                      v-if="StaffSaveStatus"
                      variant="light"
                      small
                      label="Spinning"
                    ></b-spinner>
                  </button>
                </div>
              </b-modal>
            </div>
          </div>
          <!-- END ADD SERVICE MODEL -->
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
